import CampanaNotificaciones from "./CampanaNotificaciones";
import BotonInstructivo from "./BotonInstructivo";
import BotonMapaProceso from "./BotonMapaProceso";
import { useState, useRef, useEffect } from "react";
import { subirDatos, eliminarDato } from "./syncSupabase";
import { authHeader } from './supabase';

const Q = {
  azul:"#1C3FAA", azulVivo:"#2A7FFF", azulMedio:"#6B6FD6",
  grisClaro:"#E8E9F6", grisPalido:"#F4F6FB", grisOscuro:"#2B2F36",
  grisPlata:"#8E93A1", blanco:"#FFFFFF",
  verde:"#22c55e", amarillo:"#f59e0b", rojo:"#e63946", morado:"#7B5BF2",
};

const STORAGE_AC = 'alqos_analisis_causa';
const storage = {
  get: (k, def=[]) => { try { return JSON.parse(localStorage.getItem(k) || JSON.stringify(def)); } catch { return def; } },
  set: (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch(e) { console.error(e); } },
};

// ── ISHIKAWA SVG ─────────────────────────────────────────────
function IshikawaDiagram({ causas, onEdit, oscuro }) {
  const W = 700, H = 400;
  const espinas = [
    { label: "Método",       x: 150, y: 80,  angle: 35  },
    { label: "Mano de obra", x: 350, y: 80,  angle: 25  },
    { label: "Máquina",      x: 550, y: 80,  angle: 15  },
    { label: "Material",     x: 150, y: 320, angle: -35 },
    { label: "Medición",     x: 350, y: 320, angle: -25 },
    { label: "Medio amb.",   x: 550, y: 320, angle: -15 },
  ];
  const texto = oscuro ? "#c4d4f0" : "#2B2F36";
  const bordeColor = oscuro ? "#1e3a8a" : "#dde3f0";

  return (
    <div style={{ overflowX: "auto" }}>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: "100%", maxWidth: "700px", fontFamily: "sans-serif" }}>
        {/* Espina dorsal */}
        <line x1="60" y1="200" x2="620" y2="200" stroke={Q.rojo} strokeWidth="3"/>
        {/* Cabeza — efecto */}
        <rect x="620" y="170" width="70" height="60" rx="8" fill={Q.rojo} opacity="0.9"/>
        <text x="655" y="195" fontSize="9" fill="white" textAnchor="middle" fontWeight="700">EFECTO</text>
        <text x="655" y="208" fontSize="8" fill="white" textAnchor="middle">/ PROBLEMA</text>
        <polygon points="620,185 640,200 620,215" fill={Q.rojo}/>

        {espinas.map((e, i) => {
          
          
          
          
          const xEnd = e.y < 200 ? e.x + 60 : e.x + 60;

          return (
            <g key={i}>
              <line x1={e.x} y1={e.y} x2={xEnd} y2="200" stroke={Q.azulMedio} strokeWidth="1.5" strokeDasharray="none"/>
              <circle cx={e.x} cy={e.y} r="28" fill={oscuro ? "#0d2160" : "#eff6ff"} stroke={Q.azulMedio} strokeWidth="1.5"/>
              <text x={e.x} y={e.y - 3} fontSize="8.5" fill={Q.azulVivo} textAnchor="middle" fontWeight="700">{e.label}</text>
              {(causas[e.label] || []).slice(0, 2).map((c, j) => (
                <text key={j} x={e.x} y={e.y + 8 + j * 10} fontSize="7" fill={texto} textAnchor="middle">{c.slice(0, 14)}</text>
              ))}
            </g>
          );
        })}

        <text x="30" y="204" fontSize="9" fill={Q.grisPlata} fontStyle="italic">Causa →</text>
      </svg>

      {/* Edición de causas por categoría */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "10px", marginTop: "12px" }}>
        {espinas.map((e, i) => (
          <div key={i} style={{ background: oscuro ? "#091840" : Q.grisPalido, borderRadius: "10px", padding: "10px", border: `1px solid ${bordeColor}` }}>
            <p style={{ fontSize: "11px", fontWeight: "700", color: Q.azulVivo, margin: "0 0 6px", textTransform: "uppercase", letterSpacing: ".05em" }}>{e.label}</p>
            {(causas[e.label] || []).map((c, j) => (
              <div key={j} style={{ display: "flex", gap: "6px", marginBottom: "4px" }}>
                <span style={{ fontSize: "11px", color: oscuro ? "#c4d4f0" : Q.grisOscuro, flex: 1 }}>• {c}</span>
                <button onClick={() => onEdit(e.label, j, null)} style={{ background: "none", border: "none", color: Q.rojo, cursor: "pointer", fontSize: "14px", lineHeight: 1 }}>×</button>
              </div>
            ))}
            <input placeholder="+ Agregar causa..." onKeyDown={ev => { if (ev.key === "Enter" && ev.target.value.trim()) { onEdit(e.label, -1, ev.target.value.trim()); ev.target.value = ""; } }}
              style={{ width: "100%", padding: "5px 8px", borderRadius: "6px", border: `1px solid ${bordeColor}`, fontSize: "11px", background: oscuro ? "#0d2160" : "white", color: oscuro ? "#c4d4f0" : Q.grisOscuro, boxSizing: "border-box", marginTop: "4px" }}/>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── 5 PORQUÉS ─────────────────────────────────────────────────
function CincoPorques({ porques, onChange, oscuro }) {
  const borde = oscuro ? "#1e3a8a" : "#dde3f0";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#c4d4f0" : Q.grisOscuro;

  return (
    <div>
      {[1,2,3,4,5].map(n => (
        <div key={n} style={{ display: "flex", gap: "10px", marginBottom: "10px", alignItems: "flex-start" }}>
          <div style={{ width: "32px", height: "32px", borderRadius: "50%", background: porques[n-1] ? Q.rojo : (oscuro ? "#1e3a8a" : Q.grisClaro), display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: "4px" }}>
            <span style={{ fontSize: "12px", fontWeight: "700", color: porques[n-1] ? "white" : Q.grisPlata }}>{n}</span>
          </div>
          <div style={{ flex: 1 }}>
            <p style={{ fontSize: "11px", color: Q.grisPlata, margin: "0 0 4px", fontWeight: "600" }}>¿Por qué? {n}</p>
            <textarea value={porques[n-1] || ""} onChange={e => { const nuevos = [...porques]; nuevos[n-1] = e.target.value; onChange(nuevos); }} rows={2}
              placeholder={n === 1 ? "¿Por qué ocurrió el problema?" : `¿Por qué ${n > 1 ? (porques[n-2] ? `"${porques[n-2].slice(0,30)}..."` : "ocurrió lo anterior?") : ""}?`}
              style={{ width: "100%", padding: "8px 12px", borderRadius: "8px", border: `1px solid ${porques[n-1] ? Q.rojo+"60" : borde}`, fontSize: "12px", background: cardBg, color: texto, resize: "none", boxSizing: "border-box", fontFamily: "sans-serif" }}/>
          </div>
          {n < 5 && porques[n-1] && (
            <div style={{ width: "2px", position: "absolute", left: "15px", height: "10px", background: Q.rojo, marginTop: "36px" }}/>
          )}
        </div>
      ))}
      {porques[4] && (
        <div style={{ background: oscuro ? "#0a1f0a" : "#f0fff4", border: `1px solid ${Q.verde}40`, borderRadius: "10px", padding: "12px", marginTop: "8px" }}>
          <p style={{ fontSize: "11px", color: Q.verde, fontWeight: "700", margin: "0 0 4px" }}>✅ CAUSA RAÍZ IDENTIFICADA</p>
          <p style={{ fontSize: "13px", color: texto, margin: 0 }}>{porques[4]}</p>
        </div>
      )}
    </div>
  );
}

// ── MATRIZ ESFUERZO-IMPACTO ───────────────────────────────────
function MatrizEsfuerzoImpacto({ items, onAdd, onRemove, oscuro }) {
  const [form, setForm] = useState({ accion: "", esfuerzo: "medio", impacto: "medio" });
  const borde = oscuro ? "#1e3a8a" : "#dde3f0";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#c4d4f0" : Q.grisOscuro;

  const cuadrantes = [
    { e: "bajo",  i: "alto",  label: "🚀 Ganar rápido",    color: Q.verde,    desc: "Hacelo ya" },
    { e: "alto",  i: "alto",  label: "🎯 Proyectos clave", color: Q.azulVivo, desc: "Planificá" },
    { e: "bajo",  i: "bajo",  label: "🔧 Tareas menores",  color: Q.amarillo, desc: "Si hay tiempo" },
    { e: "alto",  i: "bajo",  label: "❌ Evitar",          color: Q.rojo,     desc: "No vale la pena" },
  ];

  return (
    <div>
      <div style={{ display: "flex", gap: "8px", marginBottom: "12px", flexWrap: "wrap" }}>
        <input value={form.accion} onChange={e => setForm(f=>({...f,accion:e.target.value}))} placeholder="Acción / mejora propuesta..."
          style={{ flex: 2, padding: "8px 12px", borderRadius: "8px", border: `1px solid ${borde}`, fontSize: "13px", background: cardBg, color: texto, minWidth: "160px" }}/>
        <select value={form.esfuerzo} onChange={e => setForm(f=>({...f,esfuerzo:e.target.value}))} style={{ flex: 1, padding: "8px", borderRadius: "8px", border: `1px solid ${borde}`, fontSize: "12px", background: cardBg, color: texto, minWidth: "100px" }}>
          <option value="bajo">Esfuerzo Bajo</option>
          <option value="alto">Esfuerzo Alto</option>
        </select>
        <select value={form.impacto} onChange={e => setForm(f=>({...f,impacto:e.target.value}))} style={{ flex: 1, padding: "8px", borderRadius: "8px", border: `1px solid ${borde}`, fontSize: "12px", background: cardBg, color: texto, minWidth: "100px" }}>
          <option value="alto">Impacto Alto</option>
          <option value="bajo">Impacto Bajo</option>
        </select>
        <button onClick={() => { if (form.accion.trim()) { onAdd({...form, id: Date.now()}); setForm({accion:"",esfuerzo:"medio",impacto:"medio"}); }}}
          style={{ padding: "8px 16px", background: Q.azulVivo, color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>
          + Agregar
        </button>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
        {cuadrantes.map((q, i) => (
          <div key={i} style={{ background: oscuro ? "#091840" : Q.grisPalido, borderRadius: "10px", padding: "10px", border: `2px solid ${q.color}30` }}>
            <p style={{ fontSize: "11px", fontWeight: "700", color: q.color, margin: "0 0 4px" }}>{q.label}</p>
            <p style={{ fontSize: "10px", color: Q.grisPlata, margin: "0 0 8px" }}>Esfuerzo {q.e} · Impacto {q.i} · {q.desc}</p>
            {items.filter(it => it.esfuerzo === q.e && it.impacto === q.i).map(it => (
              <div key={it.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: oscuro?"#0d2160":"white", borderRadius: "6px", padding: "5px 8px", marginBottom: "4px", fontSize: "12px", color: texto }}>
                <span>{it.accion}</span>
                <button onClick={() => onRemove(it.id)} style={{ background: "none", border: "none", color: Q.rojo, cursor: "pointer", fontSize: "14px" }}>×</button>
              </div>
            ))}
            {items.filter(it => it.esfuerzo === q.e && it.impacto === q.i).length === 0 && (
              <p style={{ fontSize: "11px", color: Q.grisPlata, fontStyle: "italic", margin: 0 }}>Sin acciones</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

// ── FMEA SIMPLIFICADO ─────────────────────────────────────────
function FMEASimple({ modos, onAdd, onRemove, oscuro }) {
  const [form, setForm] = useState({ modo: "", efecto: "", causa: "", s: 5, o: 5, d: 5, accion: "" });
  const borde = oscuro ? "#1e3a8a" : "#dde3f0";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#c4d4f0" : Q.grisOscuro;

  const npr = form.s * form.o * form.d;
  const nprColor = npr >= 200 ? Q.rojo : npr >= 100 ? Q.amarillo : Q.verde;

  return (
    <div>
      <div style={{ background: oscuro ? "#091840" : Q.grisPalido, borderRadius: "10px", padding: "12px", marginBottom: "12px", border: `1px solid ${borde}` }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "8px", marginBottom: "8px" }}>
          <div><p style={{ fontSize: "11px", color: Q.grisPlata, margin: "0 0 4px" }}>Modo de falla</p><input value={form.modo} onChange={e=>setForm(f=>({...f,modo:e.target.value}))} style={{ width:"100%", padding:"7px", borderRadius:"7px", border:`1px solid ${borde}`, fontSize:"12px", background:cardBg, color:texto, boxSizing:"border-box" }}/></div>
          <div><p style={{ fontSize: "11px", color: Q.grisPlata, margin: "0 0 4px" }}>Efecto</p><input value={form.efecto} onChange={e=>setForm(f=>({...f,efecto:e.target.value}))} style={{ width:"100%", padding:"7px", borderRadius:"7px", border:`1px solid ${borde}`, fontSize:"12px", background:cardBg, color:texto, boxSizing:"border-box" }}/></div>
          <div><p style={{ fontSize: "11px", color: Q.grisPlata, margin: "0 0 4px" }}>Causa</p><input value={form.causa} onChange={e=>setForm(f=>({...f,causa:e.target.value}))} style={{ width:"100%", padding:"7px", borderRadius:"7px", border:`1px solid ${borde}`, fontSize:"12px", background:cardBg, color:texto, boxSizing:"border-box" }}/></div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr auto", gap: "8px", alignItems: "end" }}>
          {[["S (Severidad)",form.s,"s"],["O (Ocurrencia)",form.o,"o"],["D (Detección)",form.d,"d"]].map(([label,val,key]) => (
            <div key={key}>
              <p style={{ fontSize: "10px", color: Q.grisPlata, margin: "0 0 4px" }}>{label}</p>
              <input type="number" min="1" max="10" value={val} onChange={e=>setForm(f=>({...f,[key]:Number(e.target.value)}))} style={{ width:"100%", padding:"7px", borderRadius:"7px", border:`1px solid ${borde}`, fontSize:"13px", fontWeight:"700", background:cardBg, color:texto, boxSizing:"border-box", textAlign:"center" }}/>
            </div>
          ))}
          <div style={{ textAlign: "center" }}>
            <p style={{ fontSize: "10px", color: Q.grisPlata, margin: "0 0 4px" }}>NPR</p>
            <div style={{ padding: "7px", borderRadius: "7px", background: `${nprColor}22`, border: `1px solid ${nprColor}`, fontSize: "14px", fontWeight: "800", color: nprColor, textAlign: "center" }}>{npr}</div>
          </div>
          <button onClick={() => { if (form.modo.trim()) { onAdd({...form, npr, id: Date.now()}); setForm({modo:"",efecto:"",causa:"",s:5,o:5,d:5,accion:""}); }}}
            style={{ padding: "7px 14px", background: Q.azulVivo, color: "white", border: "none", borderRadius: "7px", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>
            + Agregar
          </button>
        </div>
      </div>
      {modos.length > 0 && (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
            <thead>
              <tr style={{ background: oscuro?"#091840":Q.grisPalido }}>
                {["Modo de falla","Efecto","Causa","S","O","D","NPR",""].map(h => <th key={h} style={{ padding: "7px 10px", textAlign:"left", fontSize:"10px", color:Q.grisPlata, fontWeight:"700", borderBottom:`1px solid ${borde}` }}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {modos.sort((a,b)=>b.npr-a.npr).map(m => {
                const c = m.npr>=200?Q.rojo:m.npr>=100?Q.amarillo:Q.verde;
                return (
                  <tr key={m.id} style={{ borderBottom: `0.5px solid ${borde}` }}>
                    <td style={{ padding:"6px 10px", color:texto }}>{m.modo}</td>
                    <td style={{ padding:"6px 10px", color:texto }}>{m.efecto}</td>
                    <td style={{ padding:"6px 10px", color:texto }}>{m.causa}</td>
                    <td style={{ padding:"6px 10px", textAlign:"center", color:texto }}>{m.s}</td>
                    <td style={{ padding:"6px 10px", textAlign:"center", color:texto }}>{m.o}</td>
                    <td style={{ padding:"6px 10px", textAlign:"center", color:texto }}>{m.d}</td>
                    <td style={{ padding:"6px 10px", textAlign:"center", fontWeight:"700", color:c }}>{m.npr}</td>
                    <td style={{ padding:"6px 10px" }}><button onClick={()=>onRemove(m.id)} style={{ background:"none", border:"none", color:Q.rojo, cursor:"pointer", fontSize:"14px" }}>×</button></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ── DIAGRAMA DE PARETO ────────────────────────────────────────
function Pareto({ items, onAdd, onRemove, oscuro }) {
  const [form, setForm] = useState({ categoria: "", frecuencia: "" });
  const borde = oscuro ? "#1e3a8a" : "#dde3f0";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#c4d4f0" : Q.grisOscuro;

  const total = items.reduce((a,b) => a + Number(b.frecuencia), 0);
  const sorted = [...items].sort((a,b) => b.frecuencia - a.frecuencia);
  let acum = 0;
  const W = 400, H = 180, pad = 40;

  return (
    <div>
      <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
        <input value={form.categoria} onChange={e=>setForm(f=>({...f,categoria:e.target.value}))} placeholder="Categoría / defecto..."
          style={{ flex:2, padding:"8px 12px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"13px", background:cardBg, color:texto }}/>
        <input type="number" value={form.frecuencia} onChange={e=>setForm(f=>({...f,frecuencia:e.target.value}))} placeholder="Frecuencia"
          style={{ flex:1, padding:"8px 12px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"13px", background:cardBg, color:texto }}/>
        <button onClick={() => { if (form.categoria.trim() && form.frecuencia) { onAdd({...form, id:Date.now(), frecuencia:Number(form.frecuencia)}); setForm({categoria:"",frecuencia:""}); }}}
          style={{ padding:"8px 16px", background:Q.azulVivo, color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"13px", fontWeight:"600" }}>
          + Agregar
        </button>
      </div>
      {sorted.length >= 2 && (
        <svg viewBox={`0 0 ${W} ${H+30}`} style={{ width:"100%", maxWidth:"500px", display:"block", margin:"0 auto 12px" }}>
          {sorted.map((item, i) => {
            const bw = (W - pad*2) / sorted.length;
            const bh = total > 0 ? ((item.frecuencia / total) * (H - pad)) : 0;
            const x = pad + i * bw;
            const y = H - bh;
            acum += item.frecuencia;
            const acumPct = total > 0 ? (acum / total) * 100 : 0;
            const px = pad + (i + 0.5) * bw;
            const py = H - ((acumPct / 100) * (H - pad));
            return (
              <g key={item.id}>
                <rect x={x+2} y={y} width={bw-4} height={bh} fill={Q.azulVivo+"cc"} rx="2"/>
                <text x={x+bw/2} y={H+12} fontSize="8" fill={Q.grisPlata} textAnchor="middle">{item.categoria.slice(0,8)}</text>
                {i > 0 && (() => {
                  const prevAcum = sorted.slice(0,i).reduce((a,b)=>a+b.frecuencia,0);
                  const prevPct = total > 0 ? (prevAcum/total)*100 : 0;
                  const prevPx = pad + (i-0.5) * bw;
                  const prevPy = H - ((prevPct/100)*(H-pad));
                  return <line x1={prevPx} y1={prevPy} x2={px} y2={py} stroke={Q.rojo} strokeWidth="1.5"/>;
                })()}
                <circle cx={px} cy={py} r="3" fill={Q.rojo}/>
              </g>
            );
          })}
          <line x1={pad} y1={H} x2={W-pad} y2={H} stroke={oscuro?"#334":"#ccc"} strokeWidth="1"/>
          <line x1={pad} y1={pad/2} x2={pad} y2={H} stroke={oscuro?"#334":"#ccc"} strokeWidth="1"/>
          {[80].map(pct => {
            const lineY = H - ((pct/100)*(H-pad));
            return <line key={pct} x1={pad} y1={lineY} x2={W-pad} y2={lineY} stroke={Q.amarillo} strokeWidth="0.8" strokeDasharray="4 2"/>;
          })}
          <text x={pad-2} y={H-(0.8*(H-pad))+3} fontSize="7" fill={Q.amarillo} textAnchor="end">80%</text>
        </svg>
      )}
      {sorted.map(item => (
        <div key={item.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 10px", background:oscuro?"#091840":Q.grisPalido, borderRadius:"8px", marginBottom:"4px", fontSize:"12px" }}>
          <span style={{ color:texto }}>{item.categoria}</span>
          <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
            <span style={{ color:Q.azulVivo, fontWeight:"700" }}>{item.frecuencia}</span>
            <span style={{ color:Q.grisPlata }}>{total>0?((item.frecuencia/total)*100).toFixed(1):0}%</span>
            <button onClick={()=>onRemove(item.id)} style={{ background:"none", border:"none", color:Q.rojo, cursor:"pointer", fontSize:"14px" }}>×</button>
          </div>
        </div>
      ))}
    </div>
  );
}

// ── PLAN DE ACCIÓN ────────────────────────────────────────────
function PlanAccion({ acciones, onAdd, onRemove, onUpdate, oscuro }) {
  const [form, setForm] = useState({ que: "", quien: "", cuando: "", como: "", estado: "pendiente" });
  const borde = oscuro ? "#1e3a8a" : "#dde3f0";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#c4d4f0" : Q.grisOscuro;
  const estadoColor = { pendiente: Q.amarillo, en_proceso: Q.azulVivo, completado: Q.verde };

  return (
    <div>
      <div style={{ background: oscuro?"#091840":Q.grisPalido, borderRadius:"10px", padding:"12px", marginBottom:"12px", border:`1px solid ${borde}` }}>
        <div style={{ display:"grid", gridTemplateColumns:"2fr 1fr 1fr", gap:"8px", marginBottom:"8px" }}>
          <div><p style={{ fontSize:"10px", color:Q.grisPlata, margin:"0 0 4px" }}>¿Qué?</p><input value={form.que} onChange={e=>setForm(f=>({...f,que:e.target.value}))} style={{ width:"100%", padding:"7px", borderRadius:"7px", border:`1px solid ${borde}`, fontSize:"12px", background:cardBg, color:texto, boxSizing:"border-box" }}/></div>
          <div><p style={{ fontSize:"10px", color:Q.grisPlata, margin:"0 0 4px" }}>¿Quién?</p><input value={form.quien} onChange={e=>setForm(f=>({...f,quien:e.target.value}))} style={{ width:"100%", padding:"7px", borderRadius:"7px", border:`1px solid ${borde}`, fontSize:"12px", background:cardBg, color:texto, boxSizing:"border-box" }}/></div>
          <div><p style={{ fontSize:"10px", color:Q.grisPlata, margin:"0 0 4px" }}>¿Cuándo?</p><input type="date" value={form.cuando} onChange={e=>setForm(f=>({...f,cuando:e.target.value}))} style={{ width:"100%", padding:"7px", borderRadius:"7px", border:`1px solid ${borde}`, fontSize:"12px", background:cardBg, color:texto, boxSizing:"border-box" }}/></div>
        </div>
        <div style={{ display:"flex", gap:"8px" }}>
          <input value={form.como} onChange={e=>setForm(f=>({...f,como:e.target.value}))} placeholder="¿Cómo? (descripción de la acción)" style={{ flex:1, padding:"7px", borderRadius:"7px", border:`1px solid ${borde}`, fontSize:"12px", background:cardBg, color:texto }}/>
          <button onClick={() => { if (form.que.trim()) { onAdd({...form, id:Date.now()}); setForm({que:"",quien:"",cuando:"",como:"",estado:"pendiente"}); }}}
            style={{ padding:"7px 14px", background:Q.azulVivo, color:"white", border:"none", borderRadius:"7px", cursor:"pointer", fontSize:"13px", fontWeight:"600" }}>
            + Agregar
          </button>
        </div>
      </div>
      {acciones.map(a => (
        <div key={a.id} style={{ background:cardBg, borderRadius:"10px", padding:"10px 12px", border:`1px solid ${estadoColor[a.estado]||Q.amarillo}40`, marginBottom:"8px" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
            <div style={{ flex:1 }}>
              <p style={{ fontSize:"13px", fontWeight:"600", color:texto, margin:"0 0 4px" }}>{a.que}</p>
              <p style={{ fontSize:"11px", color:Q.grisPlata, margin:0 }}>👤 {a.quien || "—"} · 📅 {a.cuando || "—"}{a.como && ` · ${a.como}`}</p>
            </div>
            <div style={{ display:"flex", gap:"6px", alignItems:"center" }}>
              <select value={a.estado} onChange={e=>onUpdate(a.id,"estado",e.target.value)} style={{ padding:"4px 8px", borderRadius:"6px", border:`1px solid ${estadoColor[a.estado]}`, background:`${estadoColor[a.estado]}15`, color:estadoColor[a.estado], fontSize:"11px", fontWeight:"600", cursor:"pointer" }}>
                <option value="pendiente">⏳ Pendiente</option>
                <option value="en_proceso">🔵 En proceso</option>
                <option value="completado">✅ Completado</option>
              </select>
              <button onClick={()=>onRemove(a.id)} style={{ background:"none", border:"none", color:Q.rojo, cursor:"pointer", fontSize:"16px" }}>×</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// ── COMPONENTE PRINCIPAL ──────────────────────────────────────
export default function AnalisisCausa({ onVolver, oscuro, usuario, ncInicial }) {
  const [analisis, setAnalisis] = useState(() => storage.get(STORAGE_AC, []));
  const [activo, setActivo] = useState(null);
  const [vista, setVista] = useState("listado");
  const [tab, setTab] = useState("5porques");
  const [cargandoARIA, setCargandoARIA] = useState(false);
  const [formNuevo, setFormNuevo] = useState({ titulo: ncInicial?.nci || "", problema: ncInicial?.descripcion || "", nciRelacionado: ncInicial?.nci || "" });
  const [ncVinculada, setNcVinculada] = useState(null);
  const subirDebounceRef = useRef(null);
  useEffect(() => () => clearTimeout(subirDebounceRef.current), []);

  const buscarNC = (nciStr) => {
    try {
      const ncs = JSON.parse(localStorage.getItem('alqos_ncs') || '[]');
      const found = ncs.find(n => n.nci?.toLowerCase() === nciStr?.toLowerCase().trim());
      setNcVinculada(found || null);
      if (found) {
        setFormNuevo(f => ({
          ...f,
          titulo: f.titulo || found.nci,
          problema: f.problema || found.descripcion || "",
          nciRelacionado: found.nci,
        }));
      }
    } catch { setNcVinculada(null); }
  };

  const bg       = oscuro ? "#09184D" : Q.grisPalido;
  const cardBg   = oscuro ? "#0d2160" : Q.blanco;
  const texto    = oscuro ? "#EDF2FA" : Q.grisOscuro;
  const borde    = oscuro ? "#1e3a8a" : Q.grisClaro;
  const navBg    = oscuro ? "#060f30" : Q.azul;
  const subtexto = oscuro ? "#9aabd4" : Q.grisPlata;
  const inp = { width:"100%", padding:"8px 12px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"13px", boxSizing:"border-box", marginTop:"4px", background:cardBg, color:texto, fontFamily:"sans-serif" };
  const lbl = { fontSize:"11px", color:subtexto, fontWeight:"700", display:"block", marginTop:"12px", textTransform:"uppercase", letterSpacing:".05em" };
  const card = { background:cardBg, borderRadius:"14px", padding:"1.5rem", border:`1px solid ${borde}`, marginBottom:"14px" };

  const guardar = (actualizado) => {
    const nuevos = analisis.map(a => a.id === actualizado.id ? actualizado : a);
    setAnalisis(nuevos);
    storage.set(STORAGE_AC, nuevos);
    setActivo(actualizado);
    // Guardado local inmediato; el upload a Supabase se debouncea porque guardar() se dispara
    // en cada tecla/click de los editores de 5 Porqués, Ishikawa, Pareto, FMEA, Matriz y Plan.
    clearTimeout(subirDebounceRef.current);
    subirDebounceRef.current = setTimeout(() => subirDatos(STORAGE_AC), 1500);
  };

  const crearAnalisis = () => {
    if (!formNuevo.titulo.trim() || !formNuevo.problema.trim()) { alert("Completá título y problema."); return; }
    const nuevo = {
      id: Date.now(),
      titulo: formNuevo.titulo,
      problema: formNuevo.problema,
      nciRelacionado: formNuevo.nciRelacionado,
      fecha: new Date().toISOString(),
      creadoPor: usuario?.nombre,
      porques: ["","","","",""],
      ishikawa: {},
      matrizItems: [],
      fmeaModos: [],
      paretoItems: [],
      planAcciones: [],
      causaRaizFinal: "",
      accionCorrectiva: "",
    };
    const nuevos = [nuevo, ...analisis];
    setAnalisis(nuevos);
    storage.set(STORAGE_AC, nuevos);
    subirDatos(STORAGE_AC);
    setActivo(nuevo);
    setVista("detalle");
    setFormNuevo({ titulo:"", problema:"", nciRelacionado:"" });
  };

  const eliminarAnalisis = async (id) => {
    const nuevos = analisis.filter(a => a.id !== id);
    setAnalisis(nuevos);
    storage.set(STORAGE_AC, nuevos);
    await eliminarDato(STORAGE_AC, id);
    setActivo(null);
    setVista("listado");
  };


  const analizarConARIA = async () => {
    if (!activo) return;
    setCargandoARIA(true);
    try {
      const prompt = `Sos un experto en herramientas de calidad ISO 9001. Analizá el siguiente problema de no conformidad industrial y respondé SOLO en JSON válido sin markdown ni backticks.

Problema: ${activo.problema}
NC relacionada: ${activo.nciRelacionado || "No especificada"}
Datos de la NC: ${(() => { try { const ncs = JSON.parse(localStorage.getItem('alqos_ncs')||'[]'); const nc = ncs.find(n=>n.nci===activo.nciRelacionado); if(!nc) return "No disponibles"; return `Proceso: ${nc.proceso||'-'} | Origen: ${nc.origen||'-'} | Tipo: ${nc.tipoNC||'-'} | Cliente: ${nc.cliente||'-'} | Trabajo: ${nc.trabajo||'-'} | Severidad: ${nc.severidad||'-'} | Acción inmediata: ${nc.accionInmediata||'-'}`; } catch { return "No disponibles"; } })()}
Contexto: Empresa gráfica (impresión offset, estuches de cartón). Procesos: Pre Prensa, Impresión, Post Prensa, Control de Calidad, Expedición.

Respondé con este JSON exacto:
{
  "requiereAnalisis": true o false,
  "justificacion": "Por qué requiere o no requiere análisis formal",
  "herramientaRecomendada": "5 Porqués" o "Ishikawa" o "Pareto" o "FMEA",
  "razonHerramienta": "Por qué esta herramienta es la más adecuada",
  "porques": ["respuesta porqué 1", "respuesta porqué 2", "respuesta porqué 3", "respuesta porqué 4", "respuesta porqué 5"],
  "causaRaiz": "Causa raíz identificada en una oración clara",
  "accionCorrectiva": "Acción correctiva concreta y específica",
  "leccionesAprendidas": "Lección aprendida para prevenir recurrencia",
  "planAcciones": [
    {"que": "acción específica", "quien": "rol responsable", "cuando": "plazo en días como YYYY-MM-DD desde hoy", "como": "método de implementación"},
    {"que": "segunda acción", "quien": "rol responsable", "cuando": "YYYY-MM-DD", "como": "método"}
  ]
}`;

      const response = await fetch("/api/aria", {
        method: "POST",
        headers: { ...(await authHeader()),
          "Content-Type": "application/json",
          "anthropic-version": "2023-06-01",
          },
        body: JSON.stringify({
          model: "claude-sonnet-4-5",
          max_tokens: 2000,
          messages: [{ role: "user", content: prompt }]
        })
      });

      const data = await response.json();
      const texto = data.content?.[0]?.text || "";
      const limpio = texto.replace(/```json/g,"").replace(/```/g,"").trim();
      const resultado = JSON.parse(limpio);

      if (!resultado.requiereAnalisis) {
        const actualizado = {
          ...activo,
          ariaJustificacion: resultado.justificacion,
          ariaNoRequiere: true,
          causaRaizFinal: resultado.causaRaiz || activo.causaRaizFinal,
          accionCorrectiva: resultado.accionCorrectiva || activo.accionCorrectiva,
        };
        guardar(actualizado);
        setTab("cierre");
      } else {
        
        const acciones = (resultado.planAcciones || []).map(a => ({ ...a, id: Date.now() + Math.random(), estado: "pendiente" }));
        const actualizado = {
          ...activo,
          ariaHerramienta: resultado.herramientaRecomendada,
          ariaRazon: resultado.razonHerramienta,
          ariaJustificacion: resultado.justificacion,
          porques: resultado.porques || activo.porques,
          causaRaizFinal: resultado.causaRaiz || activo.causaRaizFinal,
          accionCorrectiva: resultado.accionCorrectiva || activo.accionCorrectiva,
          leccionesAprendidas: resultado.leccionesAprendidas || activo.leccionesAprendidas,
          planAcciones: acciones.length > 0 ? acciones : activo.planAcciones,
        };
        guardar(actualizado);
        setTab(resultado.herramientaRecomendada === "Ishikawa" ? "ishikawa" : resultado.herramientaRecomendada === "Pareto" ? "pareto" : resultado.herramientaRecomendada === "FMEA" ? "fmea" : "5porques");
      }
    } catch(e) {
      console.error(e);
      alert("Error al conectar con ARIA. Verificá tu conexión.");
    }
    setCargandoARIA(false);
  };

  const exportarAnalisis = () => {
    if (!activo) return;
    const texto = `ALQOS™ — ANÁLISIS DE CAUSA
NCI: ${activo.nciRelacionado || "—"}
Título: ${activo.titulo}
Problema: ${activo.problema}
Fecha: ${new Date(activo.fecha).toLocaleString('es-AR')}
Creado por: ${activo.creadoPor}

── 5 PORQUÉS ──
${activo.porques.map((p,i) => `${i+1}. ${p||"—"}`).join("\n")}

── CAUSA RAÍZ FINAL ──
${activo.causaRaizFinal || "Sin definir"}

── ACCIÓN CORRECTIVA ──
${activo.accionCorrectiva || "Sin definir"}

── PLAN DE ACCIÓN ──
${activo.planAcciones.map(a => `• ${a.que} | ${a.quien} | ${a.cuando} | ${a.estado}`).join("\n") || "Sin acciones"}
`;
    const blob = new Blob([texto], { type:"text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `Analisis_${activo.titulo.slice(0,20)}_${new Date().toISOString().slice(0,10)}.txt`;
    a.click(); URL.revokeObjectURL(url);
  };

  const tabs = [
    { id:"5porques",  label:"🔴 5 Porqués"     },
    { id:"ishikawa",  label:"🐟 Ishikawa"       },
    { id:"pareto",    label:"📊 Pareto"         },
    { id:"fmea",      label:"⚠️ FMEA"           },
    { id:"matriz",    label:"🎯 Esfuerzo/Impacto"},
    { id:"plan",      label:"📋 Plan de acción" },
    { id:"cierre",    label:"✅ Cierre"          },
  ];

  // ── DETALLE ──
  if (vista === "detalle" && activo) return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <div style={{ background:navBg, padding:".8rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100 }}>
        <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
          <button onClick={() => setVista("listado")} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Volver</button>
          <span style={{ color:"white", fontWeight:"700", fontSize:"15px" }}>🔬 {activo.titulo}</span>
          {activo.nciRelacionado && <span style={{ background:"rgba(230,57,70,.2)", border:"1px solid rgba(230,57,70,.4)", color:"#e63946", fontSize:"10px", padding:"2px 8px", borderRadius:"10px" }}>{activo.nciRelacionado}</span>}
        </div>
        <div style={{ display:"flex", gap:"8px" }}>
          <button onClick={analizarConARIA} disabled={cargandoARIA}
            style={{ background:cargandoARIA?"rgba(123,91,242,.3)":"linear-gradient(135deg,#7B5BF2,#09184D)", border:"none", color:"white", padding:"6px 14px", borderRadius:"8px", cursor:cargandoARIA?"default":"pointer", fontSize:"12px", fontWeight:"600" }}>
            {cargandoARIA ? "🤖 Analizando..." : "🤖 Analizar con ARIA"}
          </button>
          <button onClick={exportarAnalisis} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 12px", borderRadius:"8px", cursor:"pointer", fontSize:"12px" }}>📤 Exportar</button>
          <button onClick={() => eliminarAnalisis(activo.id)} style={{ background:"rgba(230,57,70,.2)", border:"1px solid rgba(230,57,70,.4)", color:"#e63946", padding:"6px 12px", borderRadius:"8px", cursor:"pointer", fontSize:"12px" }}>🗑 Eliminar</button>
        </div>
      </div>

      <div style={{ padding:"1rem 1.5rem", maxWidth:"860px", margin:"0 auto" }}>
        {/* Info */}
        <div style={{ ...card, background:oscuro?"#0a1f5c":"#eff6ff", border:`1px solid ${Q.azulVivo}30`, marginBottom:"1rem" }}>
          <p style={{ fontSize:"13px", color:subtexto, margin:"0 0 4px" }}>Problema a analizar</p>
          <p style={{ fontSize:"14px", fontWeight:"600", color:texto, margin:0 }}>{activo.problema}</p>
        </div>

        {/* Tabs */}
        <div style={{ display:"flex", gap:"4px", marginBottom:"1rem", overflowX:"auto", paddingBottom:"4px" }}>
          {tabs.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)}
              style={{ padding:"7px 12px", borderRadius:"8px", border:"none", cursor:"pointer", fontSize:"11px", fontWeight:"700", whiteSpace:"nowrap", background:tab===t.id?`linear-gradient(135deg,${Q.azulVivo},${Q.azul})`:"transparent", color:tab===t.id?"white":subtexto, flexShrink:0 }}>
              {t.label}
            </button>
          ))}
        </div>

        {/* 5 Porqués */}
        {tab === "5porques" && (
          <div style={card}>
            <h3 style={{ fontSize:"14px", fontWeight:"700", color:Q.rojo, marginBottom:"16px" }}>🔴 Método de los 5 Porqués</h3>
            <CincoPorques porques={activo.porques} oscuro={oscuro}
              onChange={p => guardar({...activo, porques:p, causaRaizFinal: p[4] || activo.causaRaizFinal})}/>
          </div>
        )}

        {/* Ishikawa */}
        {tab === "ishikawa" && (
          <div style={card}>
            <h3 style={{ fontSize:"14px", fontWeight:"700", color:Q.azulVivo, marginBottom:"16px" }}>🐟 Diagrama de Ishikawa (6M)</h3>
            <IshikawaDiagram causas={activo.ishikawa} oscuro={oscuro}
              onEdit={(categoria, idx, valor) => {
                const nuevasCausas = { ...activo.ishikawa };
                if (!nuevasCausas[categoria]) nuevasCausas[categoria] = [];
                if (valor === null) nuevasCausas[categoria] = nuevasCausas[categoria].filter((_,i) => i !== idx);
                else nuevasCausas[categoria] = [...nuevasCausas[categoria], valor];
                guardar({...activo, ishikawa: nuevasCausas});
              }}/>
          </div>
        )}

        {/* Pareto */}
        {tab === "pareto" && (
          <div style={card}>
            <h3 style={{ fontSize:"14px", fontWeight:"700", color:Q.azulVivo, marginBottom:"16px" }}>📊 Diagrama de Pareto (80/20)</h3>
            <Pareto items={activo.paretoItems} oscuro={oscuro}
              onAdd={item => guardar({...activo, paretoItems:[...activo.paretoItems, item]})}
              onRemove={id => guardar({...activo, paretoItems:activo.paretoItems.filter(i=>i.id!==id)})}/>
          </div>
        )}

        {/* FMEA */}
        {tab === "fmea" && (
          <div style={card}>
            <h3 style={{ fontSize:"14px", fontWeight:"700", color:Q.amarillo, marginBottom:"16px" }}>⚠️ Análisis FMEA (Modo de Falla y Efectos)</h3>
            <p style={{ fontSize:"12px", color:subtexto, marginBottom:"12px" }}>S×O×D = NPR · 🔴 ≥200 crítico · 🟡 100-199 mayor · 🟢 &lt;100 menor</p>
            <FMEASimple modos={activo.fmeaModos} oscuro={oscuro}
              onAdd={modo => guardar({...activo, fmeaModos:[...activo.fmeaModos, modo]})}
              onRemove={id => guardar({...activo, fmeaModos:activo.fmeaModos.filter(m=>m.id!==id)})}/>
          </div>
        )}

        {/* Matriz Esfuerzo-Impacto */}
        {tab === "matriz" && (
          <div style={card}>
            <h3 style={{ fontSize:"14px", fontWeight:"700", color:Q.verde, marginBottom:"16px" }}>🎯 Matriz Esfuerzo vs Impacto</h3>
            <MatrizEsfuerzoImpacto items={activo.matrizItems} oscuro={oscuro}
              onAdd={item => guardar({...activo, matrizItems:[...activo.matrizItems, item]})}
              onRemove={id => guardar({...activo, matrizItems:activo.matrizItems.filter(i=>i.id!==id)})}/>
          </div>
        )}

        {/* Plan de acción */}
        {tab === "plan" && (
          <div style={card}>
            <h3 style={{ fontSize:"14px", fontWeight:"700", color:Q.azulVivo, marginBottom:"16px" }}>📋 Plan de Acción (5W2H)</h3>
            <PlanAccion acciones={activo.planAcciones} oscuro={oscuro}
              onAdd={a => guardar({...activo, planAcciones:[...activo.planAcciones, a]})}
              onRemove={id => guardar({...activo, planAcciones:activo.planAcciones.filter(a=>a.id!==id)})}
              onUpdate={(id,campo,val) => guardar({...activo, planAcciones:activo.planAcciones.map(a=>a.id===id?{...a,[campo]:val}:a)})}/>
          </div>
        )}

        {/* Cierre */}
        {tab === "cierre" && (
          <div style={card}>
            {activo.ariaHerramienta && (
              <div style={{ background:oscuro?"#0a1f5c":"#eff6ff", borderRadius:"10px", padding:"12px", marginBottom:"14px", border:"1px solid #3b82f640" }}>
                <p style={{ fontSize:"11px", fontWeight:"700", color:"#3b82f6", margin:"0 0 6px" }}>🤖 Análisis ARIA</p>
                <p style={{ fontSize:"12px", color:texto, margin:"0 0 4px" }}>Herramienta recomendada: <strong style={{color:Q.azulVivo}}>{activo.ariaHerramienta}</strong></p>
                <p style={{ fontSize:"12px", color:subtexto, margin:0 }}>{activo.ariaRazon}</p>
              </div>
            )}
            {activo.ariaNoRequiere && (
              <div style={{ background:oscuro?"#0a1f0a":"#f0fff4", borderRadius:"10px", padding:"12px", marginBottom:"14px", border:`1px solid ${Q.verde}40` }}>
                <p style={{ fontSize:"11px", fontWeight:"700", color:Q.verde, margin:"0 0 6px" }}>✅ ARIA: No requiere análisis formal</p>
                <p style={{ fontSize:"12px", color:subtexto, margin:0 }}>{activo.ariaJustificacion}</p>
              </div>
            )}
            <h3 style={{ fontSize:"14px", fontWeight:"700", color:Q.verde, marginBottom:"16px" }}>✅ Cierre del análisis</h3>
            <span style={lbl}>Causa raíz final identificada</span>
            <textarea rows={3} value={activo.causaRaizFinal||""} onChange={e => guardar({...activo, causaRaizFinal:e.target.value})} style={{ ...inp, resize:"none" }} placeholder="Resumí la causa raíz identificada con todas las herramientas..."/>
            <span style={lbl}>Acción correctiva propuesta</span>
            <textarea rows={3} value={activo.accionCorrectiva||""} onChange={e => guardar({...activo, accionCorrectiva:e.target.value})} style={{ ...inp, resize:"none" }} placeholder="Describí la acción correctiva a implementar..."/>
            <span style={lbl}>Lecciones aprendidas</span>
            <textarea rows={3} value={activo.leccionesAprendidas||""} onChange={e => guardar({...activo, leccionesAprendidas:e.target.value})} style={{ ...inp, resize:"none" }} placeholder="¿Qué aprendimos? ¿Qué prevenir en el futuro?"/>

            {activo.causaRaizFinal && activo.accionCorrectiva && (
              <div style={{ marginTop:"1rem", background:oscuro?"#0a1f0a":"#f0fff4", border:`1px solid ${Q.verde}40`, borderRadius:"10px", padding:"1rem" }}>
                <p style={{ fontSize:"12px", fontWeight:"700", color:Q.verde, margin:"0 0 8px" }}>✅ Análisis completo</p>
                <p style={{ fontSize:"12px", color:texto, margin:"0 0 4px" }}><strong>Causa raíz:</strong> {activo.causaRaizFinal}</p>
                <p style={{ fontSize:"12px", color:texto, margin:0 }}><strong>Acción:</strong> {activo.accionCorrectiva}</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );

  // ── LISTADO / NUEVO ──
  return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100 }}>
        <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
          <button onClick={onVolver} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Menú</button>
          <BotonInstructivo moduloKey="analisis_causa" oscuro={oscuro} />
          {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="analisis_causa" oscuro={oscuro} />}
          <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>🔬 Análisis de Causa</span>
        </div>
        <CampanaNotificaciones oscuro={oscuro} modulo="AnalisisCausa" />
      </div>

      <div style={{ padding:"1.2rem 1.5rem", maxWidth:"860px", margin:"0 auto" }}>
        {/* Nuevo análisis */}
        <div style={{ ...card, background:oscuro?"#0a1f5c":"#eff6ff", border:`1px solid ${Q.azulVivo}30` }}>
          <h3 style={{ fontSize:"14px", fontWeight:"700", color:Q.azulVivo, marginBottom:"12px" }}>+ Nuevo análisis</h3>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"8px" }}>
            <div>
              <span style={lbl}>Título *</span>
              <input value={formNuevo.titulo} onChange={e=>setFormNuevo(f=>({...f,titulo:e.target.value}))} style={inp} placeholder="Ej: Análisis falla impresión"/>
            </div>
            <div>
              <span style={lbl}>NCI relacionado</span>
              <input value={formNuevo.nciRelacionado} onChange={e=>{ setFormNuevo(f=>({...f,nciRelacionado:e.target.value})); buscarNC(e.target.value); }} style={inp} placeholder="Ej: NCI-2026-001"/>
            </div>
          </div>
          <span style={lbl}>Descripción del problema *</span>
          <textarea rows={2} value={formNuevo.problema} onChange={e=>setFormNuevo(f=>({...f,problema:e.target.value}))} style={{ ...inp, resize:"none" }} placeholder="Describí el problema a analizar..."/>
          {ncVinculada && (
          <div style={{ marginTop:"8px", padding:"8px 12px", background:"#eff6ff", borderRadius:"8px", border:"1px solid #3b82f640", fontSize:"11px", color:"#1C3FAA" }}>
            ✅ NC vinculada: <strong>{ncVinculada.nci}</strong> — {ncVinculada.descripcion?.slice(0,60)}{ncVinculada.descripcion?.length>60?"...":""}
            <span style={{marginLeft:"8px", color:"#6B6FD6"}}>| {ncVinculada.proceso} | {ncVinculada.tipoNC}</span>
          </div>
        )}
        <button onClick={crearAnalisis} style={{ marginTop:"12px", padding:"10px 24px", background:`linear-gradient(135deg,${Q.azulVivo},${Q.azul})`, color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontSize:"13px", fontWeight:"700" }}>
            Crear análisis →
          </button>
        </div>

        {/* Lista */}
        {analisis.length === 0 ? (
          <div style={{ textAlign:"center", padding:"3rem" }}>
            <p style={{ fontSize:"40px" }}>🔬</p>
            <p style={{ fontSize:"15px", color:texto, fontWeight:"600" }}>Sin análisis de causa</p>
            <p style={{ fontSize:"13px", color:subtexto }}>Creá un análisis desde una NC o directamente desde acá</p>
          </div>
        ) : analisis.map(a => (
          <div key={a.id} onClick={() => { setActivo(a); setVista("detalle"); }}
            style={{ background:cardBg, borderRadius:"14px", padding:"1.2rem 1.5rem", border:`1px solid ${borde}`, marginBottom:"10px", cursor:"pointer" }}
            onMouseEnter={e=>e.currentTarget.style.boxShadow=`0 4px 16px ${Q.azulVivo}20`}
            onMouseLeave={e=>e.currentTarget.style.boxShadow="none"}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
              <div>
                <p style={{ fontSize:"14px", fontWeight:"700", color:texto, margin:"0 0 4px" }}>{a.titulo}</p>
                <p style={{ fontSize:"12px", color:subtexto, margin:"0 0 4px" }}>{a.problema?.slice(0,60)}{a.problema?.length>60?"...":""}</p>
                <div style={{ display:"flex", gap:"8px", flexWrap:"wrap" }}>
                  {a.nciRelacionado && <span style={{ fontSize:"10px", color:Q.rojo, background:`${Q.rojo}15`, padding:"2px 8px", borderRadius:"8px", fontWeight:"600" }}>{a.nciRelacionado}</span>}
                  {a.causaRaizFinal && <span style={{ fontSize:"10px", color:Q.verde, background:`${Q.verde}15`, padding:"2px 8px", borderRadius:"8px", fontWeight:"600" }}>✅ Causa raíz identificada</span>}
                  {a.planAcciones?.length > 0 && <span style={{ fontSize:"10px", color:Q.azulVivo, background:`${Q.azulVivo}15`, padding:"2px 8px", borderRadius:"8px" }}>{a.planAcciones.length} acciones</span>}
                </div>
              </div>
              <p style={{ fontSize:"11px", color:subtexto, margin:0, flexShrink:0 }}>{new Date(a.fecha).toLocaleDateString('es-AR')}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}